module.exports = __webpack_public_path__ + "assets/img/contact.a2b66172.svg";